import React, { Component } from 'react'
import { connect } from 'react-redux'
import { List } from 'immutable'
import AssignAll from './AssignAll'
import AssignAllChipList from './AssignAllChipList'

class StepAssign extends Component {
  state = {
    openZoom: false,
    activeListId: null,
    tasksData: {},
  }

  componentDidMount() {
    const { setInitAssign, tasks, initAssign } = this.props

    if (!initAssign) {
      this.setTasks(this.mapStoreTasks(tasks))
    }

    setInitAssign(true)
  }

  shouldComponentUpdate(nextProps) {
    const { tasks } = this.props
    const { tasks: nextTasks } = nextProps

    if (tasks !== nextTasks) {
      this.setTasks(this.mapStoreTasks(nextTasks))

      return false
    }

    return true
  }

  mapStoreTasks = tasks =>
    tasks.map(task => ({
      workflow_task: task.id,
      assigned_users: task.assigned_users.map(item => item.id),
      assigned_user_groups: task.assigned_user_groups.map(item => item.id),
    }))

  setTasks = tasks => {
    const { assignData, updateAssign } = this.props
    const allAssignedUsers = []
    const allAssignedGroups = []

    tasks.forEach(task => {
      allAssignedUsers.push(task.assigned_users)
      allAssignedGroups.push(task.assigned_user_groups)
    })

    const groups = assignData.get('groupList').toArray()
    const users = assignData.get('userList').toArray()
    const allSelectedUsers = []
    const allSelectedGroups = []

    groups.forEach(group => {
      const groupObj = group.toObject()

      if (
        allAssignedGroups.every(allGroups => allGroups.includes(groupObj.id))
      ) {
        allSelectedGroups.push(groupObj.id)
      }
    })

    users.forEach(user => {
      const userObj = user.toObject()

      if (allAssignedUsers.every(allUsers => allUsers.includes(userObj.id))) {
        allSelectedUsers.push(userObj.id)
      }
    })

    updateAssign({
      formTasks: tasks,
      allSelectedUsers,
      allSelectedGroups,
    })
  }

  onSetTask = task => {
    this.setTasks(
      this.props.formTasks.map(item =>
        item.workflow_task === task.workflow_task ? task : item,
      ),
    )
  }

  onSetAllTasks = (task, value) => {
    const { formTasks } = this.props

    if (value.prefix === 'group') {
      this.setTasks(
        formTasks.map(item => {
          const newGroups = value.selected
            ? [...item.assigned_user_groups, value.id]
            : item.assigned_user_groups.filter(group => group !== value.id)

          return { ...item, assigned_user_groups: newGroups }
        }),
      )
    } else {
      this.setTasks(
        formTasks.map(item => {
          const newUsers = value.selected
            ? [...item.assigned_users, value.id]
            : item.assigned_users.filter(user => user !== value.id)

          return { ...item, assigned_users: newUsers }
        }),
      )
    }
  }

  onClearAll = () => {
    const { formTasks } = this.props

    this.setTasks(
      formTasks.map(item => ({
        ...item,
        assigned_users: [],
        assigned_user_groups: [],
      })),
    )
  }

  handleListChange = activeListId => {
    const {
      tasksData: stateTasksData,
      activeListId: stateActiveListId,
    } = this.state
    const stateObj = {
      activeListId,
      tasksData: {
        ...stateTasksData,
      },
    }
    const { tasksData } = stateObj

    if (stateTasksData[activeListId] === 'open') {
      tasksData[activeListId] = 'close'
    } else {
      if (stateActiveListId) {
        tasksData[stateActiveListId] = 'close'
      }

      tasksData[activeListId] = 'open'
    }

    this.setState({ ...stateObj })
  }

  onCloseAssignChipDropdown = () => {
    this.setState({ tasksData: {} })
  }

  render() {
    const { activeListId, tasksData } = this.state
    const {
      assignData,
      tasks,
      formTasks,
      allSelectedGroups,
      allSelectedUsers,
    } = this.props

    return (
      <div className="configuration-list">
        <AssignAll
          taskId="SELECT_ALL"
          groups={assignData.get('groupList')}
          users={assignData.get('userList')}
          activeListId={activeListId}
          tasksData={tasksData}
          allSelectedUsers={allSelectedUsers}
          allSelectedGroups={allSelectedGroups}
          onChange={this.onSetAllTasks}
          onClose={this.onCloseAssignChipDropdown}
          handleListChange={this.handleListChange}
          onClearAll={this.onClearAll}
        />
        {tasks.map((task, index) => (
          <AssignAllChipList
            key={task.id}
            taskId={task.id}
            label={`${index + 1}. ${task.title}`}
            groups={assignData.get('groupList')}
            groupsValues={List(task.assigned_user_groups)}
            users={assignData.get('userList')}
            usersValues={List(task.assigned_users)}
            activeListId={activeListId}
            tasksData={tasksData}
            task={formTasks.find(
              formTask => task.id === formTask.workflow_task,
            )}
            onChange={this.onSetTask}
            onClose={this.onCloseAssignChipDropdown}
            handleListChange={this.handleListChange}
          />
        ))}
      </div>
    )
  }
}

export default connect(state => ({
  assignData: state.getIn(['myJobs', 'assignData']),
  tasks: state.getIn(['myJobs', 'workflowInfo', 'tasks']),
}))(StepAssign)
